import React from 'react';
import { NavLink } from 'react-router-dom';

import { bool } from 'prop-types';
import styled from 'styled-components';
// import { StyledMenu } from './Menu.styled';


const StyledMenu = styled.nav`
  height: 100vh;
  max-height: 100vh;
  width: 100vw;
  overflow-x: hidden;
  overflow-y: hidden;
  z-index: 1 !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: ${({ theme }) => theme.primaryDark};
  transform: ${({ open }) => open ? 'translateX(0)' : 'translateX(-100%)'};
  text-align: left;
  padding: 2rem;
  position: absolute;
  top: 0;
  left: 0;
  transition: transform 0.3s ease-in-out;
  @media (min-width: ${({ theme }) => theme.desktop}) {

    }
  a {
    font-size: 2rem;
    text-transform: uppercase;
    padding: 2rem 0;
    font-weight: bold;
    letter-spacing: 0.5rem;
    color: ${({ theme }) => theme.primaryLight};
    text-decoration: none;
    transition: color 0.3s linear;
    @media (max-width: ${({ theme }) => theme.desktop}) {
      font-size: 1.5rem;
      text-align: center;
    }
  }
  a:hover {
    color:green;
    border-bottom: red !important;
  }

  .hidden {
    display: none;
  }
`;

const Menu = ({ open, setOpen, ...props }) => {

  const isHidden = open ? true : false;
  const tabIndex = isHidden ? 0 : -1;

  return (
    <StyledMenu open={open} setOpen={setOpen} aria-hidden={!isHidden} {...props}>
      <NavLink to="/" onClick={() => setOpen(false)} tabIndex={tabIndex} >
        {/* todo I can add fontawesome icon here */}
        <span aria-hidden="true"></span>
        Home
      </NavLink>
      <NavLink to="/about" onClick={() => setOpen(false)} >
        {/* todo I can add fontawesome icon here */}

        <span aria-hidden="true"></span>
        About
      </NavLink>
      <NavLink to="/blog" onClick={() => setOpen(false)} tabIndex={tabIndex} >
        {/* todo I can add fontawesome icon here */}

        <span aria-hidden="true"></span>
        Blog
      </NavLink>
      <NavLink to="/portfolio" onClick={() => setOpen(false)} tabIndex={tabIndex} activeClassName={isHidden}>
        {/* todo I can add fontawesome icon here */}
        <span aria-hidden="true"></span>
        Portfolio
      </NavLink>
      <NavLink to="/contact" onClick={() => setOpen(false)} tabIndex={tabIndex}>
        {/* todo I can add fontawesome icon here */}

        <span aria-hidden="true"></span>
        {/* todo I can add fontawesome icon here */}
        Contact
      </NavLink>
      <NavLink to="/resume" onClick={() => setOpen(false)} tabIndex={tabIndex}>
        {/* todo I can add fontawesome icon here */}
        <span aria-hidden="true"></span>
        Resume
      </NavLink>
    </StyledMenu>
  )
}

Menu.propTypes = {
  open: bool,
}

export default Menu;